import { useEffect, useRef } from 'react';

// Studio-Peak-Meter (dBFS): 0 dBFS bei ZERO_AT% der Breite, Rest Headroom/Clip. Der rAF-Loop schreibt
// direkt ans DOM (kein setState → keine Re-Renders → kein Cockpit-Ruckler).
const FLOOR_DB = -60;
const ZERO_AT = 90;
const HOT_DB = -1;
const CLIP_HOLD_MS = 3000;
const FULL_SCALE = 32767;

export function LevelMeter(props: { samplesProvider: () => Int16Array | null }) {
  const barRef = useRef<HTMLDivElement | null>(null);
  const clipRef = useRef<HTMLDivElement | null>(null);
  const raf = useRef<number | null>(null);
  const clipUntil = useRef(0);
  const providerRef = useRef(props.samplesProvider);
  providerRef.current = props.samplesProvider;

  useEffect(() => {
    function tick() {
      const s = providerRef.current();
      let pctNow = 0, hotNow = false;
      if (s && s.length > 0) {
        let peak = 0;
        for (let i = 0; i < s.length; i++) { const a = Math.abs(s[i]); if (a > peak) peak = a; }
        const db = peak > 0 ? 20 * Math.log10(peak / FULL_SCALE) : -Infinity;
        pctNow = db <= FLOOR_DB ? 0 : Math.min(ZERO_AT, ((db - FLOOR_DB) / -FLOOR_DB) * ZERO_AT);
        hotNow = db >= HOT_DB;
        if (peak >= FULL_SCALE) clipUntil.current = performance.now() + CLIP_HOLD_MS;
      }
      const bar = barRef.current;
      if (bar) { bar.style.width = `${pctNow}%`; bar.style.background = hotNow ? '#B3261E' : '#1E1E1E'; }
      const clip = clipRef.current;
      if (clip) clip.style.background = performance.now() < clipUntil.current ? '#FF3B30' : 'transparent';
      raf.current = requestAnimationFrame(tick);
    }
    raf.current = requestAnimationFrame(tick);
    return () => { if (raf.current !== null) cancelAnimationFrame(raf.current); };
  }, []);

  return (
    <div style={{ position: 'relative', background: '#ddd', width: 240, height: 12, borderRadius: 6, overflow: 'hidden', display: 'inline-block', verticalAlign: 'middle' }}>
      <div ref={barRef} style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '0%', background: '#1E1E1E', transition: 'width 50ms linear' }} />
      <div style={{ position: 'absolute', left: `${ZERO_AT}%`, top: 0, bottom: 0, width: 1, background: '#888' }} />
      <div ref={clipRef} style={{ position: 'absolute', left: `${ZERO_AT}%`, right: 0, top: 0, bottom: 0, background: 'transparent' }} />
    </div>
  );
}
